import palette from '../palette';

const MuiLinearProgress = {
  styleOverrides: {
    root: {
      backgroundColor: palette.primary.light,
      borderRadius: 5,
      height: 8,
      marginBottom: 12,
      width: '100%',
    },
  },
};

export default MuiLinearProgress;
